<template>
  <v-app>
    <template>
      <Loading v-if="LOADING" class="delA" />
      <Error />
    </template>
    <template v-if="$route.path != '/'">
      <Nav class="delA" />
    </template>
    <v-main>
      <v-container fluid :class="{ blur: LOADING }">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Loading from "./components/loading";
import Error from "./components/Error";
import Nav from "./components/Nav";
import { mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    nav: false
  }),
  created() {},

  computed: {
    ...mapGetters(["LOADING"])
  },
  watch: {},
  components: {
    Loading,
    Error,
    Nav
  }
};
</script>
<style lang="scss">
* {
  box-sizing: border-box;
}
.blur {
  filter: blur(8px);
}
@media print {
  .delA {
    display: none;
  }
  .container,
  .container--fluid,
  .v-main {
    padding: 0 !important;
    margin: 0 !important;
  }
  .printArea {
    width: 100vh;
  }
  input {
    border: none;
  }
}
</style>
